(function () {
  function start() {
    var w = document.querySelector('[data-rvb]');
    if (!w || w.dataset.bereit) return;
    w.dataset.bereit = '1';

    var opts  = w.querySelectorAll('.rvbx__opt');
    var cta   = w.querySelector('[data-rvb-cta]');
    var label = w.querySelector('[data-rvb-label]');
    var sparEl   = w.querySelector('[data-rvb-spar]');
    var fehlerEl = w.querySelector('[data-rvb-fehler]');

    var basis = parseInt(w.dataset.basis, 10);
    // Option 4 ist das Komplettpaket — dabei wandert NUR dieses Produkt in den
    // Warenkorb, nicht zusaetzlich das Pack, auf dessen Seite man gerade ist.
    var komplett = parseInt(w.dataset.komplett, 10);
    var tCta    = w.dataset.tCta || 'In den Warenkorb';
    var tLaedt  = w.dataset.tLaedt || '...';
    var tFehler = w.dataset.tFehler || 'Das hat nicht geklappt.';
    var tSpar   = w.dataset.tSpar || 'Du sparst [betrag]';
    var sparBetrag = {
      '1': '',
      '2': w.dataset.spar2 || '',
      '3': w.dataset.spar3 || '',
      '4': w.dataset.spar4 || ''
    };

    // ---------- Pack-Auswahl mit Vorschaubild ----------
    // Ein natives <select> kann keine Bilder zeigen. Deshalb bleibt das
    // <select> versteckt (es traegt weiter den Wert fuer den Warenkorb) und
    // davor sitzt ein Knopf mit Mini-Bild plus eine eigene Liste.
    var picks = w.querySelectorAll('[data-pick]');

    function alleZu(ausser) {
      Array.prototype.forEach.call(picks, function (p) {
        if (p === ausser) return;
        p.classList.remove('is-offen');
        var b = p.querySelector('[data-pbtn]');
        var m = p.querySelector('[data-menu]');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (m) m.hidden = true;
      });
    }

    function anzeigen(pick) {
      var sel  = pick.querySelector('[data-sel]');
      var img  = pick.querySelector('[data-mini]');
      var name = pick.querySelector('[data-pname]');
      var opt  = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (img && opt.dataset.bild) img.src = opt.dataset.bild;
      if (name) name.textContent = opt.textContent;
      Array.prototype.forEach.call(pick.querySelectorAll('[data-wert]'), function (it) {
        var an = it.dataset.wert === sel.value;
        it.classList.toggle('is-an', an);
        it.setAttribute('aria-selected', an ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(w.querySelectorAll('.rvbx__box'), function (box) {
      Array.prototype.forEach.call(box.querySelectorAll('[data-pick]'), function (pick, i) {
        var sel  = pick.querySelector('[data-sel]');
        var btn  = pick.querySelector('[data-pbtn]');
        var menu = pick.querySelector('[data-menu]');
        if (!sel || !btn || !menu) return;

        // Zweites und drittes Pack starten mit verschiedenen Vorschlaegen.
        if (sel.options.length > i) sel.selectedIndex = i;
        anzeigen(pick);

        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var offen = !menu.hidden;
          alleZu(pick);
          menu.hidden = offen;
          pick.classList.toggle('is-offen', !offen);
          btn.setAttribute('aria-expanded', offen ? 'false' : 'true');
          if (!offen) {
            var an = menu.querySelector('.is-an');
            if (an && an.scrollIntoView) an.scrollIntoView({ block: 'nearest' });
          }
        });

        Array.prototype.forEach.call(menu.querySelectorAll('[data-wert]'), function (it) {
          it.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            sel.value = it.dataset.wert;
            anzeigen(pick);
            alleZu(null);
            btn.focus();
          });
        });

        // Klicks in der Auswahl duerfen nicht die Option (das Label) umschalten.
        pick.addEventListener('click', function (e) { e.stopPropagation(); });
        pick.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { alleZu(null); btn.focus(); }
          e.stopPropagation();
        });
      });
    });

    document.addEventListener('click', function () { alleZu(null); });

    function aktiv() {
      var r = w.querySelector('input[name="rvb-wahl"]:checked');
      return r ? r.value : '1';
    }

    function malen() {
      var a = aktiv();
      Array.prototype.forEach.call(opts, function (o) {
        o.classList.toggle('is-an', o.dataset.opt === a);
      });
      alleZu(null);
      var b = sparBetrag[a];
      if (!b) {
        sparEl.hidden = true;
      } else {
        sparEl.hidden = false;
        sparEl.textContent = tSpar.replace('[betrag]', b);
      }
    }

    Array.prototype.forEach.call(w.querySelectorAll('input[name="rvb-wahl"]'), function (r) {
      r.addEventListener('change', malen);
    });
    malen();

    cta.addEventListener('click', function () {
      var a = aktiv();
      var items;

      if (a === '4' && komplett) {
        items = [{ id: komplett, quantity: 1 }];
      } else {
        items = [{ id: basis, quantity: 1 }];
        if (a !== '1') {
          var box = w.querySelector('.rvbx__opt[data-opt="' + a + '"] .rvbx__box');
          if (box) {
            Array.prototype.forEach.call(box.querySelectorAll('[data-sel]'), function (sel) {
              var id = parseInt(sel.value, 10);
              if (id) items.push({ id: id, quantity: 1 });
            });
          }
        }
      }

      cta.disabled = true;
      label.textContent = tLaedt;
      fehlerEl.hidden = true;

      fetch(w.dataset.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, d: d }; });
        })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.description) || 'Fehler');
          window.location.href = w.dataset.cart;
        })
        .catch(function (err) {
          cta.disabled = false;
          label.textContent = tCta;
          fehlerEl.hidden = false;
          fehlerEl.textContent = tFehler;
          if (window.console) console.warn('[rivea-bundle]', err);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
